module.exports = __webpack_public_path__ + "img/ASML.OQ.5600b0bb.png";